
import ValidatorMixin from '@/shared/mixins/validator/ValidatorMixin'
import { Component, Mixins, Prop, Watch } from 'vue-property-decorator'

import CheckoutBankTransferBank from '../models/CheckoutBankTransferBank'
import CheckoutForm from '../models/CheckoutForm'

import checkoutService from '../network/service/checkout.service'

import EButton from './Button.vue'
import EInput from './Input.vue'
import ESelect from './Select.vue'

// Must match ITAU_BANK_CODE in the backend's BankTransferValidator
const ITAU_BANK_CODE = '259'

@Component({
  components: {
    EButton,
    EInput,
    ESelect,
  },
})
export default class BankTransferForm extends Mixins(ValidatorMixin) {
  @Prop() readonly data!: CheckoutForm

  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  bankTransfer = this.data.payment.bankTransfer!

  banks: CheckoutBankTransferBank[] = []

  get isItauSelected(): boolean {
    return this.bankTransfer.bankId === ITAU_BANK_CODE
  }

  @Watch('bankTransfer.bankId')
  bankChanged(code: string | null) {
    if (code !== ITAU_BANK_CODE) {
      this.bankTransfer.debinAlias = null
    }
  }

  mounted() {
    checkoutService.bankTransferList(this.data.contractId, this.data.payment.country)
      .then((data) => this.banks = this.mapBanks(data ?? []))
  }

  private mapBanks(banks: CheckoutBankTransferBank[]) {
    // Argentina uses code '0' as a real option (OTROS); elsewhere it's a placeholder
    const options = this.data.payment.country === 'AR' ? banks : banks.filter(e => e.code !== '0')

    return options.sort((a, b) => {
      if (a.code === '0') return 1
      if (b.code === '0') return -1
      return a.name.localeCompare(b.name)
    })
  }
}
